import React from 'react';
import { View } from 'react-native';
import { rem, Spacer } from 'design-system';
import Amount from 'design-system/Amount';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const AutosaveDestination = ({ destination, potIdPotInfoMap }) => {
    const styles = useStyles(styleSet);
    const name = destination.potId === 'WALLET' ? 'Emma wallet' : potIdPotInfoMap[destination.potId]?.name ?? 'Pot';
    return (<View style={styles.container}>
      <View style={styles.infoContainer}>
        <View style={styles.flex}>
          <Text TextThin-14 Secondary numberOfLines={1}>
            {name}
          </Text>
        </View>
        <Spacer w={16}/>
        {!!destination.amount && <Amount NumbersThin-14 Secondary value={destination.amount}/>}
      </View>
    </View>);
};
export default AutosaveDestination;
const styleSet = createStyleSheets(() => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
    infoContainer: {
        flex: 1,
        flexDirection: 'row',
        paddingTop: rem(12),
        paddingBottom: rem(4),
    },
}));
